import * as tocbot from 'tocbot';

function initToc(config, refresh) {

    const defaultConfig = {
        // Where to render the table of contents.
        tocSelector: '.js-toc',
        // Where to grab the headings to build the table of contents.
        contentSelector: '.js-toc-content',
        // Which headings to grab inside of the contentSelector element.
        headingSelector: 'h1, h2, h3, h4',
        // For headings inside relative or absolute positioned containers within content.
        hasInnerContainers: true,
        // orderedList can be set to false to generate unordered lists (ul) instead of ordered lists (ol)
        orderedList: false,
        // Element to add the positionFixedClass to.
        positionFixedSelector: '.js-toc',
        // Element to add the positionFixedClass to.
        positionFixedClass: 'is-sticky-top-lg',
    };

    if (!config) {
        config = {};
    }
    const tocbotConfig = {...defaultConfig, ...config};

    if (refresh === true) {
        tocbot.refresh(tocbotConfig)
    } else {
        tocbot.init(tocbotConfig);
    }
}

function checkPosition(source, target) {
    let offset = ($('.is-main-navigation-bar.sticky.is-pinned').height() || 0);
    target.css('top', offset > 0 ? (40 + offset) : offset);
    target.css('position', offset > 0 ? 'sticky' : '');
}

export default {initToc, checkPosition}
